/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import {
  deleteEstateTemplateById,
  downloadEstateTemplateById,
  fetchEstateTemplateById,
  uploadEstateTemplate
} from '../../lib/rest/estateTemplateAPIClient'
import FileTemplateManager from '../FileTemplateManager'
import { useQuery } from '@tanstack/react-query'
import { useSettingsContext } from '../SettingsProvider'

function EstateListTemplateField () {
  const intl = useIntl()
  const filename = 'estate-list.docx'
  const { settings } = useSettingsContext()

  const handleDelete = useCallback(() => deleteEstateTemplateById(filename), [filename])
  const handleDownload = useCallback(() => downloadEstateTemplateById(filename), [filename])
  const handleUpload = useCallback((file: File) => uploadEstateTemplate(filename, file), [filename])

  const fileQuery = useQuery({
    enabled: true,
    queryKey: ['estateListTemplate', filename],
    queryFn: () => fetchEstateTemplateById(filename)
  })

  return (
    <FileTemplateManager
      accept={settings.ESTATE_TEMPLATE_FILE_TYPES}
      maxSize={settings.ESTATE_TEMPLATE_MAX_UPLOAD_SIZE}
      loading={fileQuery.isLoading}
      label={intl.formatMessage({
        id: 'estate_list_template',
        defaultMessage: 'Modèle de liste de biens'
      })}
      description={intl.formatMessage({
        id: 'estate_list_template_help',
        defaultMessage: 'Ce modèle est utilisé pour générer une liste de biens.'
      })}
      onChange={() => fileQuery.refetch()}
      onDelete={handleDelete}
      onDownload={handleDownload}
      onUpload={handleUpload}
      value={fileQuery.data ? filename : null}
      lastModified={fileQuery.data?.LastModified}
      contentLength={fileQuery.data?.ContentLength}
    />
  )
}

export default EstateListTemplateField
